import { ReactElement } from "react";
import styles from "./HorizontalLine.module.less";

export const HorizontalLine = (): ReactElement => (
	<hr className={styles.line} />
);
HorizontalLine.displayName = "ContentLayout.HorizontalLine";